import React from 'react'
import { Form } from 'react-bootstrap'
import useSchoolYear from '../../../hooks/use-school-year'
import useReflectionPrompts from '../../../hooks/use-reflection-prompts'

const ReflectionParam = ({
    label,
    value,
    onChange = () => {},
}) => {
    const { startDate } = useSchoolYear()
    const { reflectionPrompts } = useReflectionPrompts({ startDate })

    const renderPrompt = (reflectionPrompt) => {
        return (
            <option
                key={reflectionPrompt.id}
                value={reflectionPrompt.id}
            >
                {reflectionPrompt.name}
            </option>
        )
    }

    return (
        <Form.Group>
            <Form.Label>{label || 'Reflection Prompt'}</Form.Label>
            <Form.Control as="select" value={value || ''} onChange={e => onChange(e.target.value)} >
                <option value=''>Select Reflection Prompt</option>
                {reflectionPrompts.map(renderPrompt)}
            </Form.Control>
        </Form.Group>
    )
}

export default ReflectionParam